var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"clickable",on:{"click":_vm.onGroupAdd}},[_c('i',{staticClass:"mdi mdi-plus-circle-outline"}),_vm._v("\n  Insertar grupo\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }